import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'
import {
  FALLBACK_HEALTH_DATA_CONSENT_BUNDLES,
  HEALTH_DATA_CONSENT_VARIANTS,
} from '../lib/healthDataConsent'

export function useHealthDataConsentBundle(variant, { publicApi = false } = {}) {
  const basePath = publicApi ? '/public/health-data-consents/bundle' : '/health-data-consents/bundle'
  return useQuery({
    queryKey: ['health-data-consent-bundle', variant, publicApi ? 'public' : 'auth'],
    queryFn: async () => {
      try {
        const res = await api.get(basePath, { params: { variant } })
        const data = res?.data?.data ?? res?.data
        if (data?.items?.length) return data
      } catch {
        // fallback below
      }
      const fallback = FALLBACK_HEALTH_DATA_CONSENT_BUNDLES[variant]
      if (fallback) return fallback
      const meta = HEALTH_DATA_CONSENT_VARIANTS[variant]
      return { variant, bundleVersion: meta?.bundleVersion, items: meta?.items ?? [] }
    },
    staleTime: 5 * 60 * 1000,
  })
}
